import { InformationIcon } from 'components/icons';
import { Skeleton, Tooltip } from 'components/ui';

/**
 *
 * @param {{label: string,
 * amount?:number | string,
 * loading?:boolean
 * tooltip:string}} param0
 * @returns
 */
export default function MetricsItem({ label, amount, loading, tooltip }) {
  return (
    <div className="py-3 md:py-7">
      <span className="flex items-center space-x-0.5 ">
        <p className="text-xs leading-6 opacity-50 text-segments-13px md:text-base items">
          {label}
        </p>
        <Tooltip text={tooltip}>
          <div className=" hover:bg-segments-gray rounded p-0.5">
            <InformationIcon className="w-4 h-4 opacity-50" />
          </div>
        </Tooltip>
      </span>
      <Skeleton isLoaded={!loading}>
        <p className="h-8 mr-10 text-xl font-medium leading-9 md:h-9 md:text-segments-32px md:mt-1">
          {amount}
        </p>
      </Skeleton>
    </div>
  );
}
